import React, { useEffect, useRef, useState } from 'react'
import { CustomerCardModel } from '../../models/CustomerCardModel';
import './UploadDocumentPopUp.css';
import { DraftEditor } from '../../tasks/_DraftEditor';
import { set } from 'lodash';
import { setReloadFilesData } from '../../app-context/filesSlice';
import { useDispatch } from 'react-redux';



interface UploadDocumentPopUpProps {
    config: any; // Config object containing customerId and optional policyId
    onClose: () => void;
    onCloseAfterSave: () => void; // Optional callback after save
    fromPolicy?: boolean;

}

export default function EditDocumentModal({ config, onClose, onCloseAfterSave, fromPolicy }: UploadDocumentPopUpProps) {
    const customerCardModel = useRef(new CustomerCardModel()).current;
    const dispatch = useDispatch();

    const [file, setFile] = useState<any>(config.file ? config.file : null);

    const [folders, setFolders] = useState<any[]>([]);

    const [selectedFolder, setSelectedFolder] = useState<string>('');
    const [creatingFolder, setCreatingFolder] = useState(false);
    const [newFolderName, setNewFolderName] = useState('');

    const [fileTitleTypes, setFileTitleTypes] = useState<any[]>([]);

    const [selectedTitle, setSelectedTitle] = useState<string>('');
    const [creatingTitle, setCreatingTitle] = useState(false);
    const [newTitleTypeName, setNewTitleTypeName] = useState('');


    const [relationTypes, setRelationTypes] = useState<any[]>([]);
    const [selectedType, setSelectedType] = useState<string>('');



    const [relationList, setRelationList] = useState<any[]>([]);
    const [selectedRelationId, setSelectedRelationId] = useState<string>('');

    const [showRelationDataList, setShowRelationDataList] = useState<boolean>(false);
    const [finalRelationList, setFinalRelationList] = useState<any[]>([]);
    const [selectedRelation, setSelectedRelation] = useState<number>(-1);


    const [userId, setUserId] = useState<string>('');
    const [bodyContent, setBodyContent] = useState<string>(''); // for doc activities


    useEffect(() => {
        const loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            // Initialize folders based on user data if needed
            // For example, you could fetch folders from an API or set default ones
            setUserId(user.id);
        }

        setFile(config.file)
        init()
    }, []);

    const init = async () => {

        const resp = await customerCardModel.customerDocumentsGetFoldersForCustomer(config.customerId);
        if (resp && Array.isArray(resp)) {
            setFolders(resp);
        } else {
            console.error('Failed to fetch folders:', resp);
        }
        let newRelationTypes: any[] = [];
        const relationTypes = await customerCardModel.getRelationTypes();
        if (relationTypes) {
            // If relationTypes is an array, add the new item; if it's an object, adjust accordingly
            const castingArray: any[] = Object.values(relationTypes);
            newRelationTypes = castingArray.map((item: any) => ({
                id: item.id,
                name: item.name,
                description: item.description || ''
            }));
            newRelationTypes.unshift({
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            });
            await setRelationTypes(newRelationTypes);
        } else {
            // Fallback if relationTypes is not an array
            setRelationTypes([{
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            }]);
            console.error('Relation types is not an array:', relationTypes);
        }


        // If no titles are stored, fetch them from the API
        const titles = await customerCardModel.customerDocumentsGetTitles();
        if (titles && Array.isArray(titles)) {
            setFileTitleTypes(titles);
            localStorage.setItem('customerDocumentsTitle', JSON.stringify(titles));
        } else {
            console.error('Failed to fetch titles:', titles);
            setFileTitleTypes([]);
        }
        // }
        let newlist: any[] = [];
        let relationData = null;
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${config.customerId}`);
        if (storedRelations) {
            relationData = JSON.parse(storedRelations);
            console.log('storedRelations-relationDate-157', relationData)
        } else {
            relationData = await customerCardModel.treatmentsLoadRelations(config.customerId);
            sessionStorage.setItem(`treatmentsRelations-${config.customerId}`, JSON.stringify(relationData));
        }
        if (relationData) {

            console.log('treatmentsLoadRelations- relationDate-124')
            let leadsList = relationData.leads.map((lead: any) => ({
                id: lead.id,
                name: lead.identifier || '',
                type: 'Lead',
            }));
            let policiesList = relationData.policies.map((policy: any) => ({
                id: policy.id,
                name: getCompulsoryRouteId(policy) + "-" + policy.policyNumber + "/" + (policy.additionNumber ? policy.additionNumber : ''),
                type: 'Policy',
            }));
            let suesList = relationData.sues.map((sue: any) => ({
                id: sue.id,
                name: sue.sueNumber || '',
                type: 'Sue',
            }));
            let riderList = relationData.riders.map((rider: any) => ({
                id: rider.id,
                name: rider.subscriberNumber || '',
                type: 'Rider',
            }));
            newlist = [...leadsList, ...policiesList, ...suesList, ...riderList];
            setRelationList(newlist);
        }



        // If file is provided, set initial values
        setSelectedFolder(file.customerDocumentFolderId || '');
        setSelectedTitle(file.titleId || '');
        setBodyContent(file.comment || '');

        if (file.documentRelations && file.documentRelations.length > 0) {
            const relation = file.documentRelations[file.documentRelations.length - 1].type != 6 && file.documentRelations[file.documentRelations.length - 1].type != 5 ?
                file.documentRelations[file.documentRelations.length - 1] : file.documentRelations[0];

            let relationType = relationTypes[relation.type]
            let relationDataList = newlist.filter((rl) => rl.type == relationType.name);
            if (relationDataList && relationDataList.length > 0) {
                // If there are related items, you can handle them here
                setShowRelationDataList(true);
                setFinalRelationList(relationDataList);
            } else {
                setShowRelationDataList(false);
            }
            setSelectedRelationId(relation.relationId || '');
            setSelectedType(relation.type ? relation.type.toString() : '-1');
        }
    }

    const getCompulsoryRouteId = (policy: any) => {
        if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.vehiclePolicyType == 6) {
            return policy.policyAdditionDetails.route.compulsoryRouteId ? policy.policyAdditionDetails.route.compulsoryRouteId : ""
        } else if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.routeId) {
            return policy.policyAdditionDetails.route.routeId ? policy.policyAdditionDetails.route.routeId : "";
        }
        return "";
    }

    const uploadFile = async () => {
        // if (!selectedFolder || !selectedType) return;
        // set progress to 10% immediately

        try {
            const payload = {
                id: file.id,
                customerDocumentFolderId: selectedFolder || '',
                titleId: selectedTitle || '',
                comment: bodyContent || '',
                name: file.name
            };
            const resp = await customerCardModel.customerDocumentsUpdate(payload);
            console.log('uploadFile-resp', resp)

            if (!resp || resp.statusCode !== 200) {
                console.error('Failed to update document:', resp);
                onClose();
                return;
            } else {
                console.log('Document updated successfully:', resp);
            }


            console.log('uploadFile-selectedRelationId', selectedRelationId)
            console.log('uploadFile-file', file)
            if (selectedRelationId && selectedRelationId.length > 0) {
                if (file.documentRelations && file.documentRelations.length > 0 && file.documentRelations.some((x: any) => x.relationId == selectedRelationId)) {

                    console.log('uploadFile-selectedRelationId', selectedRelationId)

                    onClose();
                    // return;
                } else {
                    const RelationPayload = {
                        customerDocumentId: file.id,
                        relationId: selectedRelationId || '',
                        type: selectedType ? parseInt(selectedType) : -1,
                    }

                    const relationResp = await customerCardModel.customerDocumentsCreateRelation(RelationPayload);
                    console.log('uploadFile-relationResp', relationResp)

                    if (!relationResp || !relationResp.id) {
                        console.error('Failed to create relation:', relationResp);
                        onClose();
                        return;
                    }

                    if (relationResp && relationResp.statusCode == 200) {
                        console.log('Relation created successfully:', relationResp);
                    }


                }
            }
            // on success, mark 100% and record URL
        } catch (err) {
            console.error('Upload error for', file.name, err);

        }
        console.log('uploadFile-setReloadFilesData', true)
        dispatch(setReloadFilesData(true)); // Mark files data for reload
        onCloseAfterSave();

    };

    const createFolder = async () => {
        if (!newFolderName.trim()) return;

        let resp = await customerCardModel.customerDocumentsCreateFolder({
            name: newFolderName,
            customerId: config.customerId
        })
        if (!resp || !resp.id) {
            console.error('Failed to create folder:', resp);
            return;
        }
        // add resp to folders
        const id = resp.id; // Use the ID from the response
        console.log('New folder created:', resp);

        setFolders((f) => [...f, resp]);
        setSelectedFolder(id);
        setCreatingFolder(false);
        setNewFolderName('');
    };


    const createType = async () => {
        if (!newTitleTypeName.trim()) return;
        let resp = await customerCardModel.customerDocumentsCreateTitle({
            name: newTitleTypeName
        });
        if (!resp || !resp.id) {
            console.error('Failed to create type:', resp);
            return;
        }
        // add resp to fileTitleTypes
        const id = resp.id; // Use the ID from the response
        console.log('New type created:', resp);
        setFileTitleTypes((fileTitle) => [...fileTitle, resp]);
        // setSelectedType(id);
        setCreatingTitle(false);
        setSelectedTitle(id);
        setNewTitleTypeName('');

    }


    const onSelectRelationType = (value: string) => {
        if (value) {
            setSelectedType(value);

            let relationType = relationTypes.find((rt) => rt.id === parseInt(value));
            let relationDataList = relationList.filter((rl) => rl.type == relationType.name);

            if (relationDataList && relationDataList.length > 0) {
                // If there are related items, you can handle them here
                setShowRelationDataList(true);
                setFinalRelationList(relationDataList);
            }

        }
    }

    const onBodyChange = (html: string) => {
        console.log('onBodyChange html', html, bodyContent)
        if (html && html.length > 0) {
            setBodyContent(html);
        }
    };

    const onNameChange = (e: any) => {
        var n = e.target.value;
        setFile((prevFile: any) => prevFile ? { ...prevFile, name: n } : null);
    }

    const getNameInHebrew = (name: string) => {
        if (!name) return name;
        // Check if the name exists in the dictionary and return its Hebrew name
        // If not found, return the original name
        switch (name) {
            case 'Policy':
                return 'פוליסה';
            case 'Lead':
                return 'ליד';
            case 'Sue':
                return 'תביעה';
            case 'Offer':
                return 'הצעה';
            case 'Rider':
                return 'ריידר';
            case 'Signing':
                return 'חתימה';
            case 'Treatment':
                return 'טיפול שוטף';
            default:
                return name; // Return the original name if not found in the dictionary 
        }
    }



    return (
        <div className="udp-modal-overlay">
            <div className="udp-modal" style={{ maxWidth: '40%' }}>

                <div className="udp-header">
                    <h2>עריכת מסמך</h2>
                    <button className="udp-close-button" onClick={onClose}>X</button>
                </div>


                <div className="udp-file-info">
                    <p>שם קובץ:
                        <input type="text" placeholder="חיפוש" onChange={(e: any) => onNameChange(e)} value={file.name} />

                    </p>
                    <p>גודל קובץ: {(file.fileSize / 1024).toFixed(2)} KB</p>
                </div>

                <div className="udp-selectors">

                    <select
                        value={selectedFolder}
                        onChange={(e) => {
                            if (e.target.value === '__new__') {
                                setCreatingFolder(true);
                                setSelectedFolder('');
                            } else setSelectedFolder(e.target.value);
                        }}
                    >
                        <option value="" disabled>
                            בחר תיקייה
                        </option>
                        {folders.map((f) => (
                            <option key={f.id} value={f.id}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <p>{f.name}</p>
                                    {/* <Tooltip title="מחיקה">
                                                 <DeleteOutlined style={{
                                                    fontSize: '18px',
                                                    color: '#186cc7'
                                                }} onClick={() => deleteFolder(f.id)} /></Tooltip> */}

                                </div>
                            </option>
                        ))}
                        <option value="__new__">+ יצירת תיקייה חדשה</option>
                    </select>
                    {creatingFolder && (
                        <div className="udp-new-folder">
                            <input
                                type="text"
                                placeholder="שם תיקייה חדשה"
                                value={newFolderName}
                                onChange={(e) => setNewFolderName(e.target.value)}
                                onBlur={createFolder}
                            />
                        </div>
                    )}

                    <select
                        value={selectedTitle}

                        onChange={(e) => {
                            if (e.target.value === '__new__') {
                                setCreatingTitle(true);
                                setSelectedTitle('');
                            } else { setSelectedTitle(e.target.value); }
                        }}
                    >
                        <option value="" >
                            בחר נושא
                        </option>
                        {fileTitleTypes.map((t: any) => (
                            <option key={t.id} value={t.id}>
                                {t.name}
                            </option>
                        ))}
                        <option value="__new__">+ יצירת נושא חדש</option>
                    </select>
                    {creatingTitle && (
                        <div className="udp-new-folder">
                            <input
                                type="text"
                                placeholder="שם נושא חדש"
                                value={newTitleTypeName}
                                onChange={(e) => setNewTitleTypeName(e.target.value)}
                                onBlur={createType}
                            />
                        </div>
                    )}
                    {fromPolicy && fromPolicy === true ?
                        (<></>) :
                        <>
                            <select
                                value={selectedType}
                                onChange={(e: any) => onSelectRelationType(e.target.value)}
                            >
                                <option value={-1}>
                                    בחר סוג שיוך
                                </option>
                                {relationTypes.filter(rt => rt.id !== -1).map((rt) => (
                                    <option key={rt.id} value={rt.id}>
                                        {getNameInHebrew(rt.name)}
                                    </option>
                                ))}
                            </select>


                            {showRelationDataList && finalRelationList && finalRelationList.length > 0 && (
                                <select
                                    value={selectedRelationId}
                                    onChange={(e: any) => setSelectedRelationId(e.target.value)}
                                >
                                    <option value={-1}>
                                        בחר שיוך
                                    </option>
                                    {finalRelationList.map((rl) => (
                                        <option key={rl.id} value={rl.id}>
                                            {rl.name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </>
                    }
                </div>


                {/* <DraftEditor
                    initialHtml={bodyContent}
                    onHtmlChange={(html: string) => onBodyChange(html)}
                /> */}


                <textarea rows={4} value={bodyContent} onChange={(e: any) => setBodyContent(e.target.value)} />
                <div className="udp-footer">
                    <button className="udp-close-btn" onClick={uploadFile}>שמור</button>
                </div>


            </div>

        </div>
    )
}